import React from "react";
import MobileTitleEqipmentData from "./TitleEquipmentData";



function MobileEquipment({ Data, getData, projectList, projectId ,Type,Activity,Unit}) {
  

  return (
    <div className=" w-full  h-[70vh] overflow-y-auto">
      {Data &&
        Data.map((item, idx) => {
          return (
            <MobileTitleEqipmentData rowData={item} key={idx} getData={getData} projectList={projectList} projectId={projectId} Type={Type}  Activity={Activity}  Unit={Unit} />
          );
        })}
    </div>
  );
}

export default MobileEquipment;